/* global Swiper, Isotope, zenscroll */

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import lazysizes from 'lazysizes';
import Vue from 'vue';
import { gsap, Quad, Quint } from 'gsap/all';

require('./bootstrap');

require('./components/product-slider');
// require('./components/product-recipes');
require('./components/product-filter');
require('./components/blog-filter');
require('./components/contact-form');
require('./components/cookie-declaration');
require('./components/newsletter-component');
require('./components/video-player-component');
require('./components/video-lightbox-component');
require('./components/video-player-header');
require('./components/share-component');
require('./components/anchor-link-component');
require('./components/cooking-mode-component');
require('./components/home-highlighted-products-slider');
require('./components/tiktok-embed-component');
require('./components/instagram-reel-embed-component');
require('./components/back-to-top-component');

window.App = new Vue({
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
            showMobileMenu: false,
            showSearch: false,
            showTop: false,
            showFilters: false,
            showFilterPanel: false,
            filterBarScrolled: false,
            filter: [],
            activeTab: null,
            activeTop9: 'kidsproef',
            showLightbox: true,
            showNewsletterPopup: false,
            headerlightIsRemoved: false,
            fullSearchbar: false,
            iso: null,
            inclusives: null,
            showResetButton: false,
            activeMegaMenu: null,
            megaMenuHoverDisabled: null,
        };
    },

    computed: {
        activeFilterCount() {
            return this.inclusives ? this.inclusives.length : 0;
        },
    },

    mounted() {
        this.checkScrollUpDown();

        this.onFilterBarScroll();
        window.addEventListener('scroll', this.onFilterBarScroll, { passive: true });

        this.recipesCategoryList = document.getElementById('recipes-category-list');
        const elem = document.querySelector('.grid');
        const noResultsContainer = document.getElementById('noResultsContainer');

        if (elem) {
            window.onload = () => {
                this.iso = new Isotope(elem, {
                    // options
                    itemSelector: '.search-item',
                    layoutMode: 'fitRows',
                });

                this.iso.on('arrangeComplete', (filteredItems) => {
                    if (filteredItems.length === 0) {
                        // console.log('visible');
                        noResultsContainer.classList.add('visible');
                    } else {
                        // console.log('no-visible');
                        noResultsContainer.classList.remove('visible');
                    }
                });

                this.updateFilterCounts();

                this.applyUrlFilters();

                this.onFilterCheck();

                // this.iso.on('layoutComplete', () => {
                // this.$Lazyload.lazyLoadHandler();
                // });
            };
        }

        const tabElement = document.querySelector('[data-initial-tab="1"]');

        if (tabElement) {
            this.activeTab = tabElement.getAttribute('data-tab');
        }

        const top9Element = document.querySelector('[data-initial-top="1"]');

        if (top9Element) {
            this.activeTop9 = top9Element.getAttribute('data-top');
        }

        const swiper = new Swiper('.recipes-slider', {
            slidesPerView: 9,
            spaceBetween: 40,
            slidesPerGroup: 3,
            loop: true,
            loopFillGroupWithBlank: true,
            centeredSlides: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                },

                640: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    slidesPerGroup: 1,
                },

                768: {
                    slidesPerView: 5,
                    spaceBetween: 40,
                    slidesPerGroup: 1,
                },

                1600: {
                    slidesPerView: 7,
                    spaceBetween: 40,
                    slidesPerGroup: 1,
                },
            },

        });

        const homeSwiper = new Swiper('.home-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 6000,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // Pagination bullets
            pagination: {
                el: '.home-swiper-pagination',
                clickable: true,
            },
        });

        const blockSwiper = new Swiper('.page-block-slider', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 6000,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // Pagination bullets
            pagination: {
                el: '.page-block-swiper-pagination',
                clickable: true,
                type: 'fraction',
                renderFraction: (currentClass, totalClass) => {
                    const text = `<span class="swiper-pagination-current">${currentClass}</span> – <span class="swiper-pagination-total">${totalClass}</span>`;
                    return text;
                },
            },
        });

        const weekMenuSwiper = new Swiper('.week-menu__container', {
            slidesPerView: 5,
            spaceBetween: 20,
            loop: false,

            breakpoints: {
                320: {
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                },

                640: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },

                768: {
                    slidesPerView: 2.8,
                    spaceBetween: 10,
                },

                1024: {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                },

                1280: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
            },
        });

        const productRecipesButton = document.getElementById('product-recipes-button');
        if (productRecipesButton) {
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            if (viewportWidth > 767) {
                zenscroll.setup(null, 100);
            } else {
                zenscroll.setup(null, 45);
            }
        }

        this.injectScrambled();
    },

    methods: {
        checkScrollUpDown() {
            const { body } = document;
            const scrollUp = 'scroll-up';
            const scrollDown = 'scroll-down';
            let lastScroll = 0;
            const headerIsLight = document.querySelector('.header--light');
            if (headerIsLight) {
                document.querySelector('.header-nav').classList.add('bg-color--transparent');
            }

            window.addEventListener('scroll', () => {
                if (!this.showMobileMenu) {
                    const currentScroll = window.pageYOffset;
                    if (currentScroll <= 0) {
                        body.classList.remove(scrollUp);
                        document.querySelector('.header-nav').classList.add('bg-color--transparent');
                        if (headerIsLight) {
                            document.querySelector('#header').classList.add('header--light');
                            this.headerlightIsRemoved = false;
                        }
                        return;
                    }

                    if (
                        currentScroll > lastScroll
                        && !body.classList.contains(scrollDown)
                    ) {
                        // down
                        body.classList.remove(scrollUp);
                        body.classList.add(scrollDown);
                    } else if (
                        currentScroll < lastScroll
                        && body.classList.contains(scrollDown)
                    ) {
                        // up
                        body.classList.remove(scrollDown);
                        body.classList.add(scrollUp);
                        document.querySelector('.header-nav').classList.remove('bg-color--transparent');
                        document.querySelector('#header').classList.remove('header--light');
                        this.headerlightIsRemoved = true;
                    }
                    lastScroll = currentScroll;
                }
            });
        },

        showFullSearchbar(val, e) {
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

            if (val && !this.fullSearchbar) {
                gsap.to('.main-navigation ul', { x: -550, width: 0 });
                // gsap.to(['.header-search'], {opacity: 1, delay: 0.5})
                gsap.to(['.header-search', '.main-navigation__buttons-holder'], {
                    width: '100%',
                    onComplete: () => {
                        this.fullSearchbar = true;
                    },
                });
                if (e && e.currentTarget) {
                    e.currentTarget.querySelector('.searchform-input').focus();
                }
            } else if (this.fullSearchbar && !val) {
                // gsap.to('.header-search', {clearProps: "width", delay: 0.05})
                // if (viewportWidth > 1280) {
                //     gsap.to('.header-search', { width: 227 });
                // } else {
                gsap.to('.header-search', { width: 50 });
                // }
                gsap.to('.header-search', { clearProps: 'width', delay: 0.5 });
                gsap.to('.main-navigation ul', {
                    x: '0',
                    width: 'auto',
                    delay: 0.2,
                    duration: 0.6,
                    onComplete: () => {
                        this.fullSearchbar = false;
                    },
                });
            }
        },

        updateFilterCounts() {
            const filterButtons = document.querySelectorAll('.checkbox-input');

            const filteredItems = this.iso.getFilteredItemElements();

            for (let i = 0; i < filterButtons.length; i++) {
                const button = filterButtons[i];
                const filterValue = button.getAttribute('data-filter');

                const count = [...filteredItems].filter((el) => el.className.includes(`filter-${filterValue}`)).length;

                button.nextElementSibling.firstElementChild.innerHTML = count;

                if (count === 0) {
                    button.disabled = true;
                    button.parentElement.parentElement.classList.add('disabled');
                } else {
                    button.disabled = false;
                    button.parentElement.parentElement.classList.remove('disabled');
                }
            }
        },

        changeTab(event) {
            this.activeTab = event.currentTarget.getAttribute('data-tab');
        },

        changeTop9(event) {
            this.activeTop9 = event.currentTarget.getAttribute('data-top');
            document.getElementById('top9Current').innerHTML = event.currentTarget.innerHTML;
            this.toggleTop();
        },

        /**
        * Opens the filter panel (slide-in drawer / full-screen on mobile).
        *
        * @return {Void}
        */
        openFilterPanel() {
            this.showFilterPanel = true;
            document.body.classList.add('filter-open');
        },

        /**
        * Closes the filter panel.
        *
        * @return {Void}
        */
        closeFilterPanel() {
            this.showFilterPanel = false;
            document.body.classList.remove('filter-open');
        },

        /**
        * Docks the filter bar to the bottom once the page is scrolled.
        *
        * @return {Void}
        */
        onFilterBarScroll() {
            this.filterBarScrolled = window.scrollY > 200;
        },

        /**
        * Toggles the filter
        *
        * @return {Void}
        */
        toggleFilter(event) {
            const div1 = event.currentTarget.previousElementSibling;
            const btn = event.currentTarget;

            if (!div1.classList.contains('active')) {
                gsap.to(div1, 0.4, {
                    height: 0,
                    ease: Quad.easeIn,
                });

                div1.classList.add('active');
                btn.firstChild.classList.remove('hide');
                btn.lastElementChild.classList.add('hide');
            } else {
                gsap.to(div1, 0.4, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });

                div1.classList.remove('active');
                btn.firstChild.classList.add('hide');
                btn.lastElementChild.classList.remove('hide');
            }
        },

        /**
         * Toggles the top 9
         *
         * @return {Void}
         */
        toggleTop() {
            this.showTop = !this.showTop;

            if (this.showTop) {
                // Show
                gsap.to(this.recipesCategoryList, 0.8, {
                    height: 'auto',
                    ease: Quad.easeIn,
                });
                return;
            }

            // Hide
            gsap.to(this.recipesCategoryList, 0.8, {
                height: 0,
                ease: Quint.easeOut,
            });
        },

        onFilterCheck(event) {
            const uncheckAll = () => {
                const inputs = document.querySelectorAll('.only-one-check');
                for (let i = 0; i < inputs.length; i++) {
                    const input = inputs[i];
                    if (input !== event.currentTarget) {
                        input.checked = false;
                    }
                }
            };

            if (event) {
                const eventSlug = event.currentTarget.getAttribute('data-slug');
                const matches = document.querySelectorAll(`input[data-slug=${eventSlug}]`);

                for (let index = 0; index < matches.length; index++) {
                    const element = matches[index];
                    const li = element.parentElement.parentElement;
                    const ul = element.parentElement.parentElement.parentElement;

                    if (!event.currentTarget.checked || element.checked) {
                        li.classList.remove('hide');
                        ul.lastElementChild.classList.remove('hide');
                    } else if (!element.checked) {
                        li.classList.add('hide');
                        ul.lastElementChild.classList.add('hide');
                    }
                }
            }

            if (event) {
                if (event.currentTarget.getAttribute('data-slug') === 'allergenen') {
                    uncheckAll();
                }
            }

            // map input values to an array
            this.inclusives = [];
            // inclusive filters from checkboxes

            const checkboxes = [].slice.call(document.querySelectorAll('.checkbox-input'));

            for (let index = 0; index < checkboxes.length; index++) {
                const element = checkboxes[index];

                if (element.checked) {
                    const nextLi = element.nextSibling;
                    nextLi.classList.add('checked');
                    this.inclusives.push(`.${element.value}`);
                } else {
                    const nextLi = element.nextSibling;
                    nextLi.classList.remove('checked');
                }
            }

            // combine inclusive filters
            const filterValue = this.inclusives.length ? this.inclusives.join('') : '*';

            this.iso.arrange({ filter: filterValue });

            this.updateFilterCounts();
        },

        applyUrlFilters() {
            const urlParams = new URLSearchParams(window.location.search);
            const filterParam = urlParams.get('filter');
            if (!filterParam) return;

            const filters = filterParam.split(',');
            const checkboxes = document.querySelectorAll('.checkbox-input');

            checkboxes.forEach((checkbox) => {
                if (filters.includes(checkbox.getAttribute('data-filter'))) {
                    // eslint-disable-next-line no-param-reassign
                    checkbox.checked = true;
                }
            });
        },

        resetFilter() {
            const checkboxes = [].slice.call(document.querySelectorAll('.checkbox-input'));

            for (let index = 0; index < checkboxes.length; index++) {
                const element = checkboxes[index];

                const li = element.parentElement.parentElement;
                const ul = element.parentElement.parentElement.parentElement;
                li.classList.remove('hide');
                ul.lastElementChild.classList.remove('hide');

                element.checked = false;

                const nextLi = element.nextSibling;
                nextLi.classList.remove('checked');
            }

            this.iso.arrange({ filter: '*' });
            this.inclusives = [];

            this.updateFilterCounts();
        },

        closeFilter() {
            // Hide
            gsap.to(this.recipesCategoryList, 0.8, {
                height: 0,
                ease: Quint.easeOut,
            });
        },

        scrollToProductRecipes() {
            const recipesSection = document.getElementById('recepten');
            zenscroll.to(recipesSection);
        },

        toggleFaq(event) {
            event.currentTarget.parentElement.classList.toggle('faq--visible');
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        closeLightbox() {
            this.showLightbox = false;
            this.$refs.videoplayercomponent.stopVideo();
        },

        openNewsletterPopup() {
            this.showNewsletterPopup = true;
        },

        closeNewsletterPopup() {
            this.showNewsletterPopup = false;
        },

        scrollToNewsletter() {
            const newsletterModule = document.getElementById('newsletter-module');
            if (newsletterModule) {
                zenscroll.to(newsletterModule);
            }
        },
        scrollDown() {
            window.scrollTo({
                top: this.vhTOpx(100),
                behavior: 'smooth',
            });
        },
        vhTOpx(value) {
            const w = window;
            const d = document;
            const e = d.documentElement;
            const g = d.getElementsByTagName('body')[0];
            const x = w.innerWidth || e.clientWidth || g.clientWidth;
            const y = w.innerHeight || e.clientHeight || g.clientHeight;

            const result = (y * value) / 100;
            return result;
        },
        /**
         * Injects the Scrambled script.
         *
         * @return {Void}
         */
        injectScrambled() {
            const tag = document.createElement('script');
            tag.setAttribute('type', 'text/javascript');
            tag.setAttribute('src', '//static.scrambled.com/atml-v2.js');
            tag.async = true;
            tag.defer = true;
            (document.getElementsByTagName('head')[0] || document.documentElement).appendChild(tag);
        },

        toggleMobileMegaMenu(slug, event) {
            event.preventDefault();
            event.stopPropagation();
            if (this.activeMegaMenu === slug) {
                this.activeMegaMenu = null;
                this.megaMenuHoverDisabled = slug;
            } else {
                this.activeMegaMenu = slug;
                this.megaMenuHoverDisabled = null;
            }
        },
        resetMegaMenuHover(slug) {
            if (this.megaMenuHoverDisabled === slug) {
                this.megaMenuHoverDisabled = null;
            }
        },
    },

    beforeDestroy() {
        //
    },
});
